import type { Constructable } from "vitest";
import type { Component, DefineComponent, VNodeProps } from "vue";
import { createVNode, h, isVNode } from "vue";
import Icon from "@/components/ui/icon/Icon";

export type FlexComponent = string | Component | DefineComponent;

export const renderComponent = (
  component: FlexComponent,
  props?: (Record<string, unknown> & VNodeProps) | null
) =>
  typeof component === "string" || isVNode(component) ? component : createVNode(component, props);

export const renderIcon = (icon: FlexComponent, props?: VNodeProps & Record<string, unknown>) => {
  if (typeof icon === "string") return h(Icon, { icon, ...props });
  return renderComponent(icon, { class: "flex-icon" });
};

/**
 * Takes a component and returns a function that fits the slots
 * @param component The component constructor
 * @param key The name of the prop that will receive the scoped slot
 * @returns a compatible function with the slot
 */
export const formatSlot = <T extends Constructable>(
  component: T,
  key: keyof InstanceType<T>["$props"] = "data"
) => {
  return (item: unknown) =>
    renderComponent(component, {
      [key]: item,
    });
};
